window.setSpinner = function(){
  return("<div class='w-100 d-flex justify-content-center mt-2'><div class='spinner-border spinner-border-sm text-primary'></div></div>")
}